import React, { } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from "reactstrap";
import "./index.scss";
const Info = ({ plan, _active, _handlePlans }) => {
    return (
        <>
            <div className="info">
                <div className="items">
                    {plan?.features?.map((item, index) => (
                        <div key={index} className="rw d-flex">
                            <span>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                            {item?.name}
                        </div>
                    ))}
                    <div className="rw d-flex">
                        <span>
                            <FontAwesomeIcon icon={faCheckCircle} />
                        </span>
                        {plan?.user} users
                    </div>
                </div>
            </div>
            <div className="btm-blc mt-auto">
                {_active ? <Button outline color="secondary" >Current Plan</Button> :
                    <Button outline color="secondary" onClick={(v) => { plan?.type !== 'free' && _handlePlans(plan) }} >Choose Plan</Button>
                }
            </div>
        </>
    )
};
export default Info;